var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.16,
    width: 18,
    height: 18,
    rx: 3.789,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.876 12.17c-.352.352-.812.27-1.195-.114L8.624 10l-2.062 2.062c-.371.371-.834.424-1.198.06-.376-.377-.35-.827.04-1.217l2.063-2.062-2.189-2.19c-.383-.383-.466-.842-.113-1.195.352-.352.823-.308 1.22.09l2.189 2.188 2.069-2.069c.383-.383.834-.41 1.21-.034.364.364.318.82-.053 1.191L9.73 8.893l2.056 2.056c.397.397.441.869.09 1.221z",
    fill: "url(#b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.933,
    y1: 8.69,
    x2: 8.644,
    y2: 15.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemove);
export default __webpack_public_path__ + "static/media/ic_remove.bb9b78420ced0b07f190f0582985e69e.svg";
export { ForwardRef as ReactComponent };